import { initialCompanyActivationState } from 'redux/initialState';
import { status } from 'constants/general';

import companyActivationActionTypes from './action-types';

const companyActivationReducer = (state = initialCompanyActivationState, { type, payload }) => {
  switch (type) {
    case companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST:
      return {
        ...state,
        companyActivationList: {
          status: status.FETCHING,
        },
      };

    case companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST_SUCCESS:
      return {
        ...state,
        companyActivationList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST_FAIL:
      return {
        ...state,
        companyActivationList: {
          status: status.FAIL,
        },
      };

    case companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS:
      return {
        ...state,
        updateCompanyLicenceStatus: {
          status: status.FETCHING,
        },
      };

    case companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS_SUCCESS:
      return {
        ...state,
        updateCompanyLicenceStatus: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS_FAIL:
      return {
        ...state,
        updateCompanyLicenceStatus: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default companyActivationReducer;
